import { Component, Input } from '@angular/core';
import { BaseSelectWithIdComponent, DisplayName } from '@app/shared/components/select/base-select-with-id.component';
import { CaseParticipantUriBuilderParams, ParticipantsService } from '@app/core/services/participants.service';
import { Participant } from '@app/shared/models/participant';
import { BaseList } from '@app/shared/models/list';
import { ParticipantType, ParticipantTypes } from '@app/shared/models/participant-type';
import { HasId } from '@app/shared/models/base';
import * as _ from 'lodash-es';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { WorkflowParticipantUriBuilderParams } from '@app/core/services/workflow/workflow-participants.service';

@Component({
    selector: 'participant-type-select',
    templateUrl: '../base-select-with-id.component.html',
    styleUrls: ['../base-select-with-id.component.scss']
})
export class ParticipantTypeSelectComponent extends BaseSelectWithIdComponent<Participant, CaseParticipantUriBuilderParams | WorkflowParticipantUriBuilderParams> {

    @Input()
    private existing?: boolean; // Display the already existing types

    @Input()
    private available?: boolean; // Display the available types (are the ones that do not exist yet)

    @Input()
    private excluded?: string[]; // Type keys not to show in the dropdown

    @Input()
    private uriBuilderParams: CaseParticipantUriBuilderParams | WorkflowParticipantUriBuilderParams;


    constructor(protected participantsService: ParticipantsService) {
        super(participantsService);
        this.idSuffix = '.participant_type';
        this.defaultOptions = {
            label: marker('participant.type'),
            class: 'full-width',
            optional: true
        };
    }

    protected fetchData(): void {
        this.participantsService.getParticipantTypes(this.generateUriBuilderParams())
                                .subscribe((result: BaseList<ParticipantType>) => {
                const filtered = this.filterData(result.items);
                this.list = this.formatData(filtered);
            }, err => this.handleError(err)
        );
    }

    protected formatData(data: ParticipantType[]): ParticipantType[] & HasId[] & DisplayName[] {
        data = _.forEach(data, (pT: ParticipantType) => {
            const type = ParticipantTypes.getTypeByKey(pT.type);
            pT.translation = type && type.trans || '';
        });
        data = _.sortBy(data, (pT: ParticipantType) => pT.displayName);
        return data;
    }

    protected filterData(data: ParticipantType[]): ParticipantType[] & HasId[] & DisplayName[] {
        let filtered = data.slice(0);

        if (this.excluded) {
            filtered = _.filter(filtered, (pT: ParticipantType) => {
                return this.excluded.indexOf(pT.type) === -1;
            });
        }

        if (this.existing && !this.available) {
            filtered = _.filter(filtered, (pT: ParticipantType) => {
                return !pT.available;
            });
        } else if (this.available && !this.existing) {
            filtered = _.filter(filtered, (pT: ParticipantType) => {
                return pT.available;
            });
        }

        return filtered;
    }

    protected generateUriBuilderParams(): CaseParticipantUriBuilderParams | WorkflowParticipantUriBuilderParams {
        return this.uriBuilderParams;
    }

}
